{
  "title": "Proveedores de servicio",
  "description": "Gestione sus proveedores de servicio y su información",
  "addProvider": "Agregar proveedor",
  "searchPlaceholder": "Buscar proveedores...",
  "deleteTitle": "Eliminar proveedor",
  "deleteDescription": "¿Está seguro de que desea eliminar a {{name}}? Esta acción no se puede deshacer.",
  "deleteDescriptionGeneric": "¿Está seguro de que desea eliminar este proveedor? Esta acción no se puede deshacer.",
  "deleted": "Proveedor eliminado correctamente",
  "deleteError": "Error al eliminar el proveedor",
  "form": {
    "createTitle": "Crear proveedor",
    "createDescription": "Agregue un nuevo proveedor de servicio a su equipo",
    "editTitle": "Editar proveedor",
    "editDescription": "Actualizar información del proveedor",
    "cardTitle": "Información del proveedor",
    "cardDescription": "Ingrese los datos del nuevo proveedor",
    "editCardDescription": "Actualice los datos del proveedor",
    "image": "Imagen del proveedor",
    "imageHint": "Suba una imagen de perfil del proveedor",
    "uploading": "Subiendo...",
    "uploadFailed": "Error al subir",
    "name": "Nombre",
    "nameHint": "Nombre completo del proveedor",
    "namePlaceholder": "Ingrese el nombre del proveedor",
    "email": "Correo electrónico",
    "emailHint": "Correo electrónico del proveedor",
    "emailPlaceholder": "Ingrese la dirección de correo",
    "creating": "Creando...",
    "updating": "Actualizando...",
    "saveCreate": "Crear proveedor",
    "saveUpdate": "Actualizar proveedor",
    "nameRequired": "El nombre del proveedor es obligatorio",
    "emailRequired": "El correo electrónico es obligatorio",
    "invalidEmail": "Correo electrónico no válido",
    "noBusiness": "Seleccione un negocio antes de agregar un proveedor",
    "noBusinessId": "ID de negocio no encontrado",
    "created": "Proveedor creado correctamente",
    "createError": "Error al crear el proveedor",
    "updated": "Proveedor actualizado correctamente",
    "updateError": "Error al actualizar el proveedor",
    "notFoundTitle": "Proveedor no encontrado",
    "notFoundDescription": "No se pudo encontrar el proveedor que intenta editar.",
    "saveChanges": "Guardar cambios",
    "saving": "Guardando...",
    "editImageHint": "Suba una nueva imagen de perfil del proveedor"
  },
  "show": {
    "title": "Detalles del proveedor",
    "documentTitle": "{{name}} | Proveedores",
    "documentTitleFallback": "Detalles del proveedor",
    "emailDescription": "Correo: {{email}}",
    "actions": "Acciones",
    "editProvider": "Editar proveedor",
    "deleteProvider": "Eliminar proveedor",
    "notFoundTitle": "Proveedor no encontrado",
    "notFoundDescription": "No se pudo encontrar el proveedor que busca.",
    "loadFailed": "Error al cargar el proveedor",
    "backToProviders": "Volver a proveedores",
    "profileImage": "Imagen de perfil",
    "name": "Nombre",
    "email": "Correo electrónico",
    "assignedUnits": "Unidades asignadas",
    "unitsCount": "{{count}} unidad",
    "unitsCount_other": "{{count}} unidades",
    "notAssignedUnits": "No asignado a ninguna unidad",
    "assignedServices": "Servicios asignados",
    "assignedServiceUnits": "Unidades de servicio asignadas",
    "unnamedService": "Servicio sin nombre",
    "unnamedUnit": "Unidad sin nombre",
    "unitsForService": "{{count}} unidad(es)",
    "serviceLabel": "Servicio: {{name}}",
    "unknownService": "Desconocido",
    "viewService": "Ver servicio",
    "noAssignments": "Este proveedor aún no está asignado a ninguna unidad de servicio."
  }
}
